import React from 'react';

import { TabEmptyState } from './TabEmptyState';

export const PatientOverviewTab: React.FC = () => {
  return (
    <TabEmptyState
      title="Overview"
      description="The patient's medical information will live here."
    />
  );
};
